import { useEffect, useState } from 'react'
import { unstable_batchedUpdates as batch } from 'react-dom'

export function useAsyncFunction<T>(fn: () => Promise<T>, deps: any[]) {
  let unMounted = false
  const [value, setValue] = useState<T>(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const currentDeps = deps

    // FIXME: In react 18, we dont need use batch. https://reactjs.org/blog/2022/03/29/react-v18.html#new-feature-automatic-batching
    batch(() => {
      setValue(null)
      setLoading(true)
      setError(null)
    })

    fn()
      .then(res => {
        if (unMounted) return
        if (currentDeps !== deps) return
        batch(() => {
          setValue(res)
          setLoading(false)
        })
      })
      .catch(err => {
        if (unMounted) return
        if (currentDeps !== deps) return
        batch(() => {
          setError(err)
          setLoading(false)
        })
      })

    return () => {
      unMounted = true
    }
  }, deps)

  if (error) return { error }
  if (loading) return { loading }
  return { value }
}
